import { useCallback, useState } from 'react';

import { MAGIC_EDIT_MASK_HINT_DISMISSED_KEY } from '../constants/mask-hint-storage';

const readDismissed = () => {
  try {
    return window.localStorage.getItem(MAGIC_EDIT_MASK_HINT_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const useMagicEditMaskHint = () => {
  const [isDismissed, setIsDismissed] = useState(readDismissed);

  const dismiss = useCallback(() => {
    try {
      window.localStorage.setItem(MAGIC_EDIT_MASK_HINT_DISMISSED_KEY, 'true');
    } catch {
      // Ignore storage errors (private browsing, quota, etc.)
    }

    setIsDismissed(true);
  }, []);

  return { isDismissed, dismiss };
};
